
const state = {
  agency_id: undefined,
  id: null,
  provider_deadline_group_id: undefined,
  provider_id: undefined,
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'provider_deadline_group_id' },
  { key: 'provider_id' },
]

export default state
